import axios from "axios";
import toast from "react-hot-toast";

// Action Types
export const FETCH_HOLIDAYS_REQUEST = "FETCH_HOLIDAYS_REQUEST";
export const FETCH_HOLIDAYS_SUCCESS = "FETCH_HOLIDAYS_SUCCESS";
export const FETCH_HOLIDAYS_FAILURE = "FETCH_HOLIDAYS_FAILURE";

export const CREATE_HOLIDAY_REQUEST = "CREATE_HOLIDAY_REQUEST";
export const CREATE_HOLIDAY_SUCCESS = "CREATE_HOLIDAY_SUCCESS";
export const CREATE_HOLIDAY_FAILURE = "CREATE_HOLIDAY_FAILURE";

export const UPDATE_HOLIDAY_REQUEST = "UPDATE_HOLIDAY_REQUEST";
export const UPDATE_HOLIDAY_SUCCESS = "UPDATE_HOLIDAY_SUCCESS";
export const UPDATE_HOLIDAY_FAILURE = "UPDATE_HOLIDAY_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Fetch Holiday List
export const fetchHolidayList = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_HOLIDAYS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/get-holiday-list-admin`,
        { headers: { Authorization: token } }
      );

      if (response?.data?.meta?.status) {
        dispatch({ type: FETCH_HOLIDAYS_SUCCESS, payload: response.data.data });
      } else {
        dispatch({ type: FETCH_HOLIDAYS_FAILURE, payload: response.data?.meta?.message });
      }
    } catch (error) {
      dispatch({
        type: FETCH_HOLIDAYS_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
    }
  };
};

// // Create Holiday

export const createHoliday = (holiday_name, holiday_date, description, district_id, municipality_id) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_HOLIDAY_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/api/create-holiday`,
        { holiday_name, holiday_date, description, district_id, municipality_id },
        { headers: { Authorization: token, "Content-Type": "application/json" } }
      );

      if (response?.data?.meta?.status) {
        dispatch({ type: CREATE_HOLIDAY_SUCCESS });
        toast.success("Holiday Created Successfully");
        dispatch(fetchHolidayList());
      } else {
        dispatch({ type: CREATE_HOLIDAY_FAILURE, payload: response.data?.meta?.message });
        toast.error(response.data?.meta?.message);
      }
    } catch (error) {
      dispatch({
        type: CREATE_HOLIDAY_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      toast.error(error.response?.data?.meta?.message || "Error occurred");
    }
  };
};




// Update Holiday By Admin
export const updateHolidayByAdmin = (data) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_HOLIDAY_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(`${BASE_URL}/v1/api/admin/updateHoliday`, data, {
        headers: {
          Authorization: token,
        },
      });

      if (response?.data?.meta?.status) {
        dispatch({ type: UPDATE_HOLIDAY_SUCCESS, payload: response.data.data });
        toast.success("Holiday updated successfully");

        // Optionally refetch list (depends on your reducer structure)
        dispatch(fetchHolidayList());
      } else {
        dispatch({
          type: UPDATE_HOLIDAY_FAILURE,
          payload: response?.data?.meta?.message || "Failed to update holiday",
        });
        toast.error(response?.data?.meta?.message || "Update failed");
      }
    } catch (error) {
      dispatch({
        type: UPDATE_HOLIDAY_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      toast.error(error.response?.data?.meta?.message || "Update request failed");
    }
  };
};